import './ajax-loader.scss';
import register from 'ShopUi/app/registry';import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('ajax-loader', () =>
    importWithFallback(
        /* webpackMode: "eager" */
        () => import('./ajax-loader')
    ),
);
